// components/DocumentEditor/ImageUpload/ImageUploadToolbar.jsx
import React, { useRef } from 'react';
import { MdImage, MdCloudUpload } from 'react-icons/md';

/**
 * Toolbar button for traditional file upload
 */
const ImageUploadToolbar = ({ 
  onImageUpload, 
  disabled = false,
  className = ""
}) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    if (disabled) return;
    fileInputRef.current?.click();
  };

  const handleFileSelect = (event) => {
    const file = event.target.files?.[0];
    if (file && onImageUpload) {
      onImageUpload(file);
    }
    // Reset input to allow selecting the same file again
    event.target.value = '';
  };

  return (
    <>
      <button
        onClick={handleButtonClick}
        disabled={disabled}
        className={`
          flex items-center space-x-2 px-3 py-2 text-sm font-medium 
          rounded-lg transition-all duration-200
          ${disabled 
            ? 'text-gray-400 cursor-not-allowed bg-gray-100' 
            : 'text-gray-700 hover:text-blue-600 hover:bg-blue-50 bg-white border border-gray-200 hover:border-blue-200'
          }
          ${className}
        `}
        title="Upload Image"
      >
        <MdImage size={16} />
        <span>Image</span>
      </button>
      
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        className="hidden"
      />
    </>
  );
};

export default ImageUploadToolbar;